import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AgencyTheme } from '../types/agency';

interface ThemeState {
  themes: Record<string, AgencyTheme>;
  setTheme: (agencyId: string, theme: AgencyTheme) => void;
  getTheme: (agencyId: string) => AgencyTheme;
}

// Thème par défaut
const DEFAULT_THEME: AgencyTheme = {
  primaryColor: '#3B82F6',   // blue-600
  secondaryColor: '#1E40AF', // blue-800
  textColor: '#111827',      // gray-900
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      themes: {},
      setTheme: (agencyId, theme) => 
        set(state => ({ 
          themes: { 
            ...state.themes, 
            [agencyId]: theme 
          } 
        })),
      getTheme: (agencyId) => 
        get().themes[agencyId] || DEFAULT_THEME
    }),
    {
      name: 'theme-storage'
    }
  )
);

// Hook pour accéder au thème d'une agence spécifique
export const useAgencyTheme = (agencyId: string) => {
  return useThemeStore(state => state.getTheme(agencyId));
};

// Hook pour modifier le thème d'une agence
export const useSetAgencyTheme = () => {
  return useThemeStore(state => state.setTheme);
}; 